/* eslint-disable @typescript-eslint/no-explicit-any */
export const stubDataAllBonuses: any[] = [];
